import Avatar from '@material-ui/core/Avatar'
import Typography from '@material-ui/core/Typography'
import React from 'react'
import { useStyles } from './styles'
import Box from '@material-ui/core/Box'
import useIconAccessor from 'components/lesson-type-category/icons'
import Chip from '@material-ui/core/Chip'
import clsx from 'clsx'
import { getLessonDurationText, toFullDate } from 'utils/dateUtils'
import { flags, useFeatureFlags } from 'lib/feature-flags'
import { toThreeLetterTimezone } from 'utils/timezones'

const BookingTypeCard = ({
  category,
  facility,
  title,
  durationInMinutes,
  startDateTime,
  lessonCreditBalanceQuantity,
}) => {
  const classes = useStyles()
  const accessor = useIconAccessor()
  const [showTimezoneEnabled] = useFeatureFlags([
    flags.FLAG_TIMEZONE_EVENT_BOOKING,
  ])
  const timezone = facility?.timezone
  const formattedTimezone = toThreeLetterTimezone(timezone, startDateTime)
  const showTimezone = showTimezoneEnabled && formattedTimezone !== null
  const formatedLessonTime = `${toFullDate(
    startDateTime,
  )}, from ${getLessonDurationText(startDateTime, durationInMinutes)}`

  return (
    <div className={classes.bookingType}>
      <Box display="flex" alignItems="center" justifyContent="space-between">
        <Box display="flex" alignItems="center" mb={1}>
          <Avatar className={classes.iconStyled}>
            {accessor[category].icon}
          </Avatar>
          <div className={classes.infoWrapped}>
            <Typography
              variant="caption"
              className={`${classes.fontBolded} ${classes.captionText}`}
            >
              {title}
            </Typography>
          </div>
        </Box>
      </Box>
      <Box my={1}>
        <Chip
          className={clsx(classes.chip, classes.chipSuccess)}
          label="Purchased"
        />
        <Chip
          className={clsx(classes.chip, classes.chipInfo)}
          label={`${lessonCreditBalanceQuantity} lessons left`}
        />
      </Box>
      <div>
        <Typography
          variant="caption"
          className={`${classes.captionText} ${classes.lighterText}`}
        >
          {facility.name}
        </Typography>
        <br />
        <Typography
          variant="caption"
          className={`${classes.captionText} ${classes.lighterText}`}
        >
          {formatedLessonTime} {showTimezone ? `(${formattedTimezone})` : ''}
        </Typography>
      </div>
    </div>
  )
}

export default BookingTypeCard
